
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"81","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M58.623 46.108c.013-3.52-.904-6.98-2.657-10.02a19.62 19.62 0 00-7.31-7.274 19.323 19.323 0 00-9.945-2.518 19.338 19.338 0 00-9.833 2.933 19.65 19.65 0 00-7.006 7.575 19.938 19.938 0 00-2.243 10.123 19.906 19.906 0 003.138 9.877 19.587 19.587 0 007.654 6.902v9.702c.015.574.25 1.12.656 1.52.406.4.95.624 1.518.624h13.042a2.16 2.16 0 001.517-.625c.406-.4.642-.945.656-1.519v-9.87a19.592 19.592 0 007.828-7.177 19.916 19.916 0 002.985-10.253v0z","stroke":"currentColor","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M39.116 5.552v8.46M61.406 13.618l-5.908 6.036M74.113 31.104h-8.36M16.822 13.618l5.908 6.036M4.113 31.104h8.36","stroke":"#fff","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    